import React from "react";
import { createPortal } from "react-dom";
import classNames from "classnames";
import Button from "pages/_components/Button";
import { resizableRoute as resizableComponent } from "../Resizable";
import { DrawerPropType, defaultDrawerPropType } from "./DrawerPropType";

const Drawer = (props) => {
    const {
        type,
        className,
        children,
        isDesktop,
        isMobile,
        openSidebar,
        toggleSidebar = null,
        onClose,
        enableCloseButton,
        isFullHeight,
        notCreateInRoot,
    } = props;

    const customClassName = classNames(className, "slider", {
        "is-shown": openSidebar && !isFullHeight,
        "is-shown-full-height": isFullHeight && openSidebar,
    });

    const handleClose = () => {
        if (onClose) {
            onClose();
            return;
        }

        if (toggleSidebar) {
            toggleSidebar(false);
        }
    };

    // const openModal = () => {
    //     // dispatch(templateActions.createTemplate());
    //     setIsModalVisible(true);
    // };

    // const openModalProps = {
    //     onClick: openModal,
    //     "aria-haspopup": "dialog",
    //     "aria-expanded": isModalVisible,
    // };

    // eslint-disable-next-line no-nested-ternary
    const drawerClass = type !== "auto" ? (isDesktop ? "right" : "bottom") : type;
    const closeIcon = isDesktop ? "images/figma/icon/cross.svg" : "images/drawer-close.svg";

    const createElemInRoot = (elem) => (notCreateInRoot ? elem : createPortal(elem, document.getElementById("root")));

    return createElemInRoot(
        <div className={classNames("drawer", drawerClass, customClassName)}>
            <div
                className={classNames("drawer-content", {
                    "drawer-full-height": isMobile && isFullHeight,
                    "slideFromRight-wrapper": isDesktop,
                    "slideFromBottom-wrapper": isMobile,
                })}>
                {(enableCloseButton || isFullHeight) && (
                    <Button
                        className="view-close drawer-close-btn"
                        onClick={handleClose}
                        image={closeIcon}
                        bsStyle="link"
                    />
                )}
                {!enableCloseButton && <div className="view-close" />}
                {children}
            </div>
        </div>,
    );
};

Drawer.propTypes = DrawerPropType;
Drawer.defaultProps = defaultDrawerPropType;

export default resizableComponent(Drawer);
